module.exports = __webpack_public_path__ + "static/media/quartz_300.cc33e60c.ico";